<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2"><a id="page_xi"></a><a id="ack"></a><strong>Acknowledgments</strong></h2>
<p class="noindent">The contributors who have written or reviewed chapters for this book come from many different countries. I have always enjoyed this kind of international cooperation throughout my career. I’m very grateful to all colleagues who directly or indirectly contributed to this book and am especially honored that Dave Woll from ARC, one of the creators of the CPAS concept, has contributed a section defining the ARC CPAS vision.</p>
<p class="indent">The following persons were of invaluable assistance by reviewing one or more of the chapters: Margret Bauer, Carlos Bilich, Armin Boss, Rainer Drath, Krister Forsman, Christopher Ganz, Georg Gutermuth, Stefan Heiß, Alexander Horch, Gunnar Johannsen, Jim Kline, Michael Lundh, Dejan Milenovic, Per Erik Modén, Mikael Rudin, Wolfgang Schellhammer, Mario Schwartz, Rob Turner, and Kay Wilke. Many thanks also to my wife, Sigrid Hollender, who helped with language issues.</p>
<p class="indent">This book was made possible by the outstanding contributions of Susan Colwell (ISA) and Scott Bogue (Words<sub>2</sub> Work). They are to be recognized for their exceptional efforts in making this book a high-quality piece of work.</p>
<p class="indent">Many thanks to the following authors, who contributed insightful and well-reasoned chapters in their areas of expertise:</p>
<table border="0" cellpadding="0" cellspacing="0" width="100%">
<tbody><tr>
<td valign="top"><p class="noindent1-head"><strong>Chapter</strong></p></td>
<td valign="top"><p class="noindent1-head"><strong>Author</strong></p></td>
</tr>
<tr>
<td valign="top"><p class="noindent1">The ARC CPAS Vision</p></td>
<td valign="top"><p class="noindent1">Dave Woll</p></td>
</tr>
<tr>
<td valign="top"><p class="noindent1">OPC UA</p></td>
<td valign="top"><p class="noindent1">Wolfgang Mahnke</p></td>
</tr>
<tr>
<td valign="top"><p class="noindent1">Dependability</p></td>
<td valign="top"><p class="noindent1">Hubert Kirrmann</p></td>
</tr>
<tr>
<td valign="top"><p class="noindent1">Security</p></td>
<td valign="top"><p class="noindent1">Martin Naedele/Markus Brändle</p></td>
</tr>
<tr>
<td valign="top"><p class="noindent1">Safety</p></td>
<td valign="top"><p class="noindent1">Zaijun Hu</p></td>
</tr>
<tr>
<td valign="top"><p class="noindent1">Engineering</p></td>
<td valign="top"><p class="noindent1">Georg Gutermuth</p></td>
</tr>
<tr>
<td valign="top"><p class="noindent1">Control Logic Programming</p></td>
<td valign="top"><p class="noindent1">Georg Gutermuth</p></td>
</tr>
<tr>
<td valign="top"><p class="noindent1">CPAS Functional Units</p></td>
<td valign="top"><p class="noindent1">Christopher Ganz</p></td>
</tr>
<tr>
<td valign="top"><p class="noindent1"><a id="page_xii"></a>Common Process Control Application Structure</p></td>
<td valign="top"><p class="noindent1">David Huffman</p></td>
</tr>
<tr>
<td valign="top"><p class="noindent1">Advanced Process Control</p></td>
<td valign="top"><p class="noindent1">Alf Isaksson</p></td>
</tr>
<tr>
<td valign="top"><p class="noindent1">Loop Tuning</p></td>
<td valign="top"><p class="noindent1">Alf Isaksson</p></td>
</tr>
<tr>
<td valign="top"><p class="noindent1">Loop Monitoring</p></td>
<td valign="top"><p class="noindent1">Alexander Horch</p></td>
</tr>
<tr>
<td valign="top"><p class="noindent1">Plant Asset Management</p></td>
<td valign="top"><p class="noindent1">Alexander Horch/Margret Bauer</p></td>
</tr>
<tr>
<td valign="top"><p class="noindent1">Enterprise Connectivity</p></td>
<td valign="top"><p class="noindent1">Margret Bauer/Sascha Stoeter</p></td>
</tr>
<tr>
<td valign="top"><p class="noindent1">Planning and Scheduling</p></td>
<td valign="top"><p class="noindent1">Iiro Harjunkoski</p></td>
</tr>
<tr>
<td valign="top"><p class="noindent1">Operator Effectiveness</p></td>
<td valign="top"><p class="noindent1">Tony Atkinson/Martin Hollender</p></td>
</tr>
</tbody></table>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781937560386_07_ack.vue?6f41c630